export default "__VITE_ASSET__BW$CeR8N__"